<template>
  <div class="record-wrap">
    <van-tabs v-model="searchType" @change="changeType">
      <van-tab title="我发起的" :name="1"></van-tab>
      <van-tab title="我参与的" :name="2"></van-tab>
    </van-tabs>
    <van-list class="refreshWrap" v-model="isRefresh" @load="onLoad" finished-text="没有更多了" :finished="finished">
      <ul class="appoint-list">
        <li class="appoint" v-for="item in appointList" :key="item.ReservationID">
          <h3>{{item.MeetingTitle}}
            <span v-if="item.ReservationState === 1" style="color:#5cadff;">（待审批）</span>
            <span v-else-if="item.ReservationState === 3" style="color:#19be6b;">（同意）</span>
            <span v-else-if="item.ReservationState === 4" style="color:#f05a4a;">（不同意）</span>
            <span v-else-if="item.ReservationState === 2" style="color:#f90;">（已撤销）</span>
          </h3>
          <p class="line-info">使用日期：{{item.StartTime ? item.StartTime.slice(0, 11) : ''}}</p>
          <p class="line-info">使用时间：{{item.StartTime.slice(11, 16)}} - {{item.EndTime.slice(11, 16)}}</p>
          <p class="line-info">使用时长：{{item.UseTime}}</p>
          <p class="line-info">发起人：{{item.FullName}}</p>
          <p class="line-info">地点：{{item.HouseFullName}}</p>
          <van-divider></van-divider>
          <p class="see-btn">
            <span @click="goDetail(item.ReservationID)">
              <van-icon name="edit"></van-icon>
              <a href="javascript:;">查看</a>
            </span>
          </p>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>

  export default {
    name: 'VenueMyAppointMentList',
    data() {
      return {
        isRefresh: false,
        finished: false,
        appointList: [],
        totalItems: 0,
        pageIndex: 0,
        pageSize: 15,
        searchType: 1,
      }
    },
    created() {

    },
    methods: {
      changeType() {
        this.appointList = []
        this.pageIndex = 0;
        this.finished = false;
      },
      goDetail(id) {
        this.$router.push({name: 'myMeetingDetail', params: {id}})
      },
      async getList() {
        var params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          searchType: this.searchType
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/MeetingReservation/GetMyReservPage', params);
        if (res.success) {
          // 加载状态结束
          this.isRefresh = false;

          if (res.data.data) {
            this.totalItems = res.data.totalRecords
            this.appointList = this.appointList.concat(res.data.data)
          } else {
            this.finished = true;
          }
          if (this.appointList.length >= this.totalItems) {
            this.finished = true;
          }
        }

      },
      onLoad() {
        this.pageIndex++
        this.getList()
      }
    }
  }
</script>
<style lang="less" scoped>
  .record-wrap {
    .appoint-list {
      .appoint {
        height: 442px;
        width: 100%;
        padding: 30px 20px;
        background: #fff;
        box-sizing: border-box;
        margin-top: 16px;

        h3 {
          font-size: 28px;
          margin-bottom: 30px;
        }

        .line-info {
          font-size: 24px;
          padding: 10px;

          &:last-child {
            margin-bottom: 20px;
          }
        }

        .see-btn {
          color: #f90;
          display: flex;
          justify-content: flex-end;

          a {
            color: #f90;
            margin-left: 10px;
          }
        }

      }
    }
  }
</style>
